var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sync-progress"},[_c('i',{class:_vm.getIconClass,style:(_vm.getIconStyle)})])}
var staticRenderFns = []

export { render, staticRenderFns }